<template>
    <div class="hotel-info-wrapper">
        <div class="service-item-wra">
            <div class="title">服务设施</div>
            <div class="item-card-wrapper" :class="{more:!viewMore}" v-if="serviceItems.length>0">
                <div
                    class="each-item"
                    v-for="(item,index) in serviceItems"
                    :key="index"
                    @click.stop="triggerMore"
                >
                    <img :src="facilitySrc(index,item.url)" class="service-image">
                    <span
                        v-text="(index===7&&viewMore)?'查看更多':item.label"
                        :class="{more:index===7&&viewMore}"
                    ></span>
                </div>
            </div>
        </div>
        <div class="each-block" v-if="hotelInfo.address">
            <div class="title">酒店地址</div>
            <div class="content" @click.stop="openMap">
                <img :src="locationIconSrc" class="location" alt>
                <span v-text="hotelInfo.address"></span>
            </div>
        </div>

        <div class="each-block" v-if="hotelInfo.tel">
            <div class="title">联系电话</div>
            <div class="content">
                <a class="tel" :href="'tel:'+hotelInfo.tel" v-text="hotelInfo.tel"></a>
            </div>
        </div>

        <div class="each-block" v-if="hotelInfo.traffic">
            <div class="title">交通信息</div>
            <div class="content">
                <span v-text="hotelInfo.traffic"></span>
            </div>
        </div>

        <div class="each-block" v-if="hotelInfo.introduction">
            <div class="title">详情介绍</div>
            <div class="rich-context-wra protect-image" v-html="hotelInfo.introduction"></div>
        </div>
    </div>
</template>

<script>
const FA = [
    { label: "吧台", value: "1", url: "bar.png" },
    { label: "冰箱", value: "2", url: "fridge.png" },
    { label: "餐厅", value: "3", url: "restaurant.png" },
    { label: "残疾人设施", value: "4", url: "disabledfacility.png" },
    { label: "宠物允许", value: "5", url: "petallowed.png" },
    { label: "吹风机", value: "6", url: "blower.png" },
    { label: "电视", value: "7", url: "tv.png" },
    { label: "健身房", value: "8", url: "gym.png" },
    { label: "叫醒服务", value: "9", url: "wakeup.png" },
    { label: "接待", value: "10", url: "reception.png" },
    { label: "接送服务", value: "11", url: "pickup.png" },
    { label: "空调", value: "12", url: "airconditioner.png" },
    { label: "跑步机", value: "13", url: "treadmill.png" },
    { label: "清洁服务", value: "14", url: "cleaning.png" },
    { label: "热水洗浴", value: "15", url: "hotwater.png" },
    { label: "停车场", value: "16", url: "parking.png" },
    { label: "无线上网", value: "17", url: "wifi.png" },
    { label: "西餐", value: "18", url: "western.png" },
    { label: "洗衣机", value: "19", url: "washer.png" },
    { label: "哑铃", value: "20", url: "dumbbell.png" },
    { label: "泳池", value: "21", url: "pool.png" },
    { label: "有线上网", value: "22", url: "internet.png" },
    { label: "熨斗", value: "23", url: "iron.png" },
    { label: "其他", value: "24", url: "other.png" }
];
export default {
    name: "HotelInfo",
    components: {},
    props: {
        // layouts: String,
        // layoutType: String,
    },
    data() {
        return {
            viewMore: true,
            hotelInfo: {},
            locationIconSrc: ""
        };
    },
    computed: {
        slicedServiceItems() {
            return this.serviceItems.slice(0, 7).concat({
                url: "more-service.png",
                label: "查看更多",
                value: "999"
            });
        },
        serviceItems() {
            let { facilities } = this.hotelInfo;
            if (facilities && facilities.length > 0) {
                return facilities.map(e => {
                    return FA.find(fa => fa.value === e);
                });
            } else {
                return [];
            }
        }
    },
    watch: {},
    created() {
        // this.getHotelDetailData();
        let h = sessionStorage.hotelInfo;
        if (h) {
            this.hotelInfo = JSON.parse(h);
            this.viewMore = this.hotelInfo.facilities.length > 7;
        }
    },
    mounted() {
        this.locationIconSrc = API.ossUrl + "scene/png/location-icon.png";
    },
    destroyed() {},
    methods: {
        openMap() {
            UTILS.openMap(this.hotelInfo);
        },
        triggerMore() {
            this.viewMore = !this.viewMore;
        },
        facilitySrc(index, url) {
            return (
                API.ossUrl +
                "hotel/png/facility/" +
                (index === 7 && this.viewMore ? "more-service.png" : url)
            );
        }
    }
};
</script>
<style scoped lang="scss">
.hotel-info-wrapper {
    background: $white;
    .service-item-wra {
        padding: 0.533333rem 0.333333rem 0 0.333333rem;
        background: linear-gradient(
            to bottom,
            $blue 0%,
            $white 50%,
            $white 100%
        );
        .title {
            margin-bottom: 0.4rem;
            color: $white;
            font-weight: bold;
            font-size: 15px;
        }
        .item-card-wrapper {
            width: 100%;
            border-radius: 10px;
            box-shadow: -1px 2px 14px 0px rgba(0, 0, 0, 0.1);
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            background: $white;
            padding: 0.666667rem 0;
            max-height: 4.666667rem;
            overflow: hidden;
            transition: max-height 0.3s;
            &.more {
                max-height: 13rem;
            }
            .each-item:nth-child(8):before {
                content: "";
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                z-index: 100;
            }
            .each-item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                text-align: center;
                width: 25%;
                position: relative;
                &:nth-child(n + 5) {
                    margin-top: 0.7rem;
                }
                .service-image {
                    margin-bottom: 0.2rem;
                    width: 0.693333rem;
                    height: 0.693333rem;
                }
                span {
                    color: $grey4;
                    font-size: 12px;
                    &.more {
                        color: $blue;
                    }
                }
            }
        }
    }
    .each-block {
        @include border1px(border-bottom, #ebebeb);
        padding: 0.466667rem 0;
        margin: 0 0.4rem;
        &:last-child {
            border-bottom: 0;
        }
        .title {
            margin-bottom: 0.4rem;
            color: #484848;
            font-weight: bold;
            font-size: 15px;
        }
        .content {
            font-size: 14px;
            color: #808080;
            span {
                font-size: 14px;
                color: #808080;
            }
            .location {
                width: 0.32rem;
                height: 0.373333rem;
                vertical-align: middle;
                margin-right: 0.213333rem;
            }
            .tel {
                color: $blue;
            }
        }
    }
}
</style>

